import React from 'react';
import { BalanceSheetDataType, StockSummaryDataType } from '../../../../redux/reports/reportsType';
import { TableHeadersType } from '../../../../constant/tableHeadersConstants/tableHeadersType';
import { Link } from 'react-router-dom';
import { Iicon } from '../../../../assets/images';
import { currencySignAndNegativeValueAdjust, getStartDateFromEndDate } from '../../../../utils/commonFunctions';

type AppProps = {
  data: [] | BalanceSheetDataType[] | StockSummaryDataType[];
  netAmount: number | null | undefined;
  netAmountName: string;
  tableHeaders: TableHeadersType[];
  netBalanceSheetProfit?: number;
  client_code?: any;
  company_name?: any;
  end_date?: any;
  title?: string;
  currencySign: string;
  isLedgerStatementPresent?: boolean;
  handleCustomerSuplierDetailsData?: (invoiceType: number) => void;
  isStocksStatementPresent?:boolean;
  selectedBranchId?:any;
  branchName?:any;
  dispatchResetAllTypeLedgerListWithTaxList:()=>void;
}

const BalanceSheetTableData = ({
  data,
  netAmount,
  netAmountName,
  tableHeaders,
  client_code,
  company_name,
  end_date,
  title,
  currencySign,
  isLedgerStatementPresent,
  isStocksStatementPresent,
  handleCustomerSuplierDetailsData,
  selectedBranchId,
  branchName,
  dispatchResetAllTypeLedgerListWithTaxList
}: AppProps) => {
  const start_date= getStartDateFromEndDate(end_date);


  const finalRedirectLink = {
    pathname: `/reports/${client_code}/ledger-statement?client_code=${client_code}&company_name=${company_name}`,
  }

  const stockSummaryRedirectLink=(id:number)=> {
   return{pathname: `/reports/${client_code}/stock-statement?sku_id=${id}&client_code=${client_code}&company_name=${company_name}`} 
  }
  const handleSetLocalStorageData = (ledgerId: number) => {
    dispatchResetAllTypeLedgerListWithTaxList()
    localStorage.setItem('ledger_id', ledgerId.toString());
    localStorage.setItem('start_date', start_date);
    localStorage.setItem('branch_id',selectedBranchId)
    localStorage.setItem('branchName',branchName)
    localStorage.setItem('end_date', end_date);
  }

  const handleSetStockSummaryLocalStorageData = (stockUnitName: string) => {
    localStorage.setItem('stock_item_name', stockUnitName);
    localStorage.setItem('start_date', start_date);

    localStorage.setItem('end_date', end_date);
  }

  const renderTableData = () => {
    let finalTableData = data &&
      data?.length > 0 &&
      data?.map((data: BalanceSheetDataType | any) => {
        if(data?.closing_amount){
        let finalClosingAmount = netAmountName === 'Total Equity' ||
          netAmountName === 'Total Liabilities' ||
          netAmountName === 'Total Supplier Amount' ||
          netAmountName === 'Total Tax Payable' ?
          data?.closing_amount && data?.closing_amount == 0 ? 0 : data?.closing_amount : data?.closing_amount;
        return (
          <tr key={data?.ledger_id}>
            {
              tableHeaders &&
              tableHeaders?.length &&
              tableHeaders?.map((header: TableHeadersType) => {
                if (header?.value === 'ledger_name') {
                  return <td className='text-start'>
                    {(netAmountName==="Total Inventory" ?isStocksStatementPresent:isLedgerStatementPresent) ? (<Link
                      target='_blank'
                      to={netAmountName==="Total Inventory" ? stockSummaryRedirectLink(data?.stock_item_id) :finalRedirectLink}
                      onClick={() => netAmountName==="Total Inventory" ? handleSetStockSummaryLocalStorageData(data?.stock_item_name)  : handleSetLocalStorageData(data?.ledger_id)}
                      style={{ textDecoration: 'none' ,cursor:"pointer"}}
                    >
                      {netAmountName==="Total Inventory" ? data?.stock_item_name : data?.ledger_name}
                    </Link>) :(netAmountName==="Total Inventory" ? data?.stock_item_name : data?.ledger_name)}
                    {title === "customer" || title === "supplier" ?
                      <img className='ml-2 pointer' alt='eye' src={Iicon} onClick={() => handleCustomerSuplierDetailsData?.(data?.ledger_id)} />
                      : null}
                  </td>
                } else if (header?.value === 'closing_amount') {
                  return <td className='text-start'>
                    {currencySignAndNegativeValueAdjust(currencySign,finalClosingAmount?finalClosingAmount?.toString():"")}
                  </td>
                }
              })
            }
          </tr>
        )
  }});
    return finalTableData;
  };

  const finalNetAmount = netAmountName === 'Total Equity' ||
    netAmountName === 'Total Liabilities' ||
    netAmountName === 'Total Supplier Amount' ||
    netAmountName === 'Total Tax Payable' ?
    netAmount && netAmount === 0  ? 0 : netAmount : netAmount;

  return (
    <>
      {renderTableData()}
      <tr className='text-start'>
        <td><strong>{netAmountName}</strong></td>
        <td>
          <strong>
            {finalNetAmount === +'-0' ? 0 : currencySignAndNegativeValueAdjust(currencySign,finalNetAmount?(+finalNetAmount)?.toFixed(2)?.toString():"")}
          </strong>
        </td>
      </tr>
    </>
  )
};

export default BalanceSheetTableData;